
const getters = {
  menu: state => state.menu.data,
  permission: state => state.permission.data,
  viewRoute: state => state.viewRoute.data,
  customerSearch: state => state.customerSearch.data,
  logSearch: state => state.logSearch.data,
  siteInfo: state => state.siteInfo.data,
  contractSearch: state => state.contractSearch.data,
  adplayerSearch: state => state.adplayerSearch.data,
  repaycontractSearch: state => state.repaycontractSearch.data,
  repayindexSearch: state => state.repayindexSearch.data,
  invoceSearch: state => state.invoceSearch.data
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js